import { Link, useParams } from "react-router-dom";
import { useGetNoticeDetail } from "hooks/common/useGetNoticeDetail";
import { api_uri } from "hooks/utils/enum";
import arrow from "assets/common/support/notice_arrow.png";

export default function NoticeDetail({ type }: { type: string }) {
    const idx = useParams().idx;
    const { data, isLoading, isError } = useGetNoticeDetail({ category: type, list_no: Number(idx) });
    // console.log(data);

    // 게시글이 삭제되었거나 존재하지 않는 경우(404 등)
    const isNotFound = !isLoading && (isError || !data);

    return (
        <div
            className={
                "flex-1 bg-[#f4f4f4] responsive450:bg-white flex flex-col items-center pb-16 pt-5 responsive1200:pt-[0px] responsive1200:px-[4%] responsive450:px-0"
            }
        >
            <p className="py-[35px] text-[#333] text-[28px] font-[600] responsive1200:py-[30px] responsive1200:text-[24px] responsive450:hidden">
                공지사항
            </p>
            {isNotFound ? (
                <div
                    className={`bg-white w-full max-w-[1200px] p-[50px] flex flex-col items-center responsive1200:px-[4%] responsive450:px-0 responsive450:pt-0`}
                >
                    <div className="w-full border-t-[3px] border-t-[#999999] flex flex-col items-center justify-center text-center py-[100px] px-[15px] responsive450:border-t-0 responsive450:py-[80px]">
                        <p className="text-[20px] text-[#333333] font-[500] mb-[10px] responsive450:text-[18px]">
                            삭제되었거나 존재하지 않는 게시글입니다.
                        </p>
                        <p className="text-[15px] text-[#888888]">
                            요청하신 공지사항을 찾을 수 없습니다. 목록에서 다시 확인해 주세요.
                        </p>
                    </div>
                    <Link
                        to="/support/notices"
                        className="text-white bg-[#264180] px-[20px] py-[7px] text-[14px] self-end mt-[25px] responsive450:w-[calc(100%-32px)] responsive450:text-center responsive450:bg-transparent responsive450:text-[#1B1C1E] responsive450:border responsive450:border-[#E1E2E4] responsive450:rounded-[8px] responsive450:mx-auto"
                    >
                        목록
                    </Link>
                </div>
            ) : (
            <div
                className={`bg-white w-full max-w-[1200px] p-[50px] flex flex-col responsive1200:px-[4%] responsive450:px-0 responsive450:pt-0`}
            >
                <div className="border-t-[3px] border-t-[#999999] border-b-[1px] border-b-[#dddddd] py-[20px] px-[15px] responsive450:border-t-0">
                    <p className="text-[20px] text-[#333333] font-[500] mb-[10px]">{data?.subject}</p>
                    <span className="text-[#888888] text-[14px]">{data?.w_date}</span>
                </div>
                <div dangerouslySetInnerHTML={{ __html: data?.contents || "" }} className="py-12 px-[4%]" />

                <div className="responsive450:border-b responsive450:border-b-[12px] responsive450:border-[rgba(112, 115, 124, 0.08)]">
                    {data?.b_file && (
                        <div className="bg-[#f7f7f7] py-[20px] px-[15px] text-[15px] text-[#333333] flex gap-x-[50px] gap-y-[10px] flex-wrap">
                            <p className="text-nowrap">첨부파일</p>

                            <Link
                                to={`${api_uri}/upload/board/${data.b_file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:underline cursor-pointer break-all"
                            >
                                {data.b_file}
                            </Link>
                        </div>
                    )}
                    <div className="py-[20px] px-[15px] border-t border-[#dddddd] flex items-center gap-[10%] responsive450:hidden">
                        <div className="flex items-center gap-[20px] shrink-0">
                            <img src={arrow} alt="" />
                            <span className="text-nowrap">이전글</span>
                        </div>
                        <Link
                            to={`/support/notices/${data?.prevList ? data.prevList.list_no : data?.list_no}`}
                            className="text-[#666666] hover:text-[#243a6f] truncate"
                        >
                            {data?.prevList ? data.prevList.subject : "없음"}
                        </Link>
                    </div>
                    <div className="py-[20px] px-[15px] border-t border-[#dddddd] border-b flex items-center gap-[10%] responsive450:hidden">
                        <div className="flex items-center gap-[20px] shrink-0">
                            <img src={arrow} alt="" className="rotate-[180deg]" />
                            <span className="text-nowrap">다음글</span>
                        </div>
                        <Link
                            to={`/support/notices/${data?.nextList ? data.nextList.list_no : data?.list_no}`}
                            className="text-[#666666] hover:text-[#243a6f] truncate"
                        >
                            {data?.nextList ? data.nextList.subject : "없음"}
                        </Link>
                    </div>
                </div>

                <Link
                    to="/support/notices"
                    className="text-white bg-[#264180] px-[20px] py-[7px] text-[14px] self-end mt-[25px] responsive450:w-[calc(100%-32px)] responsive450:text-center responsive450:bg-transparent responsive450:text-[#1B1C1E] responsive450:border responsive450:border-[#E1E2E4] responsive450:rounded-[8px] responsive450:mx-auto"
                >
                    목록
                </Link>

                {/* <button type="button" className="bg-[#4d5d81] text-white text-[15px] p-[12px] mt-[35px]">
                    답변
                </button> */}
            </div>
            )}
        </div>
    );
}
